module.exports = __webpack_public_path__ + "img/load-1-1.1591169a.png";